import Link from 'next/link';
import { ChevronDown, Hamburger, Phone, XClose, JLGLogo } from '@/components/pages/icons';
import Cta from '@/components/pages/cta';
import { NavbarCtas } from './navbar-ctas';
import { NavProps } from './type';

export function Navbar({
  initialState,
  ctaHref,
  onToggleMenuOpen,
  onOpenDesktopMenu,
  onClickCta,
  phone,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
  navLinks,
}: NavProps) {
  return (
    <nav className="flex w-full items-center justify-between gap-0 px-3 py-3 @lg:py-6 @lg:px-6 transition-all duration-300 ease-in-out">
      <div className="flex items-center gap-10 @xl:gap-14 transition-all duration-300">
        <Link
          href="/"
          prefetch={false}
          className="shrink-0 text-brand-default @xl:ml-4 @lg:group-data-[initial-state=true]:text-white @lg:group-data-[initial-state=false]:text-brand-text-button @lg:group-hover:group-data-[initial-state=true]:text-brand-text-button"
          data-label
          aria-label="Link to home page"
        >
          <JLGLogo className="h-8 @lg:h-8.5 w-auto " />
        </Link>

        <div
          className="hidden items-center gap-2 @lg:flex group-data-[initial-state=true]:*:text-white group-data-[initial-state=false]:*:text-brand-text-button @lg:group-hover:group-data-[initial-state=true]:*:text-brand-text-button"
          data-label
        >
          {(navLinks || []).map((item) =>
            item.isClaimSections || item.isLocations ? (
              <Cta
                size="sm"
                variation="navlink"
                onClick={
                  onOpenDesktopMenu
                    ? () => onOpenDesktopMenu(item.isLocations ? 'locations' : 'claim')
                    : undefined
                }
                text={item.label}
                key={`desktop-${item.label}`}
                icon={<ChevronDown />}
              />
            ) : (
              <Cta
                size="sm"
                variation="navlink"
                href={item.href || '#'}
                key={`desktop-${item.label}`}
                text={item.label}
              />
            )
          )}
        </div>
      </div>

      <div className="hidden items-center gap-4 @lg:flex">
        <NavbarCtas
          initialState={initialState}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          phone={phone}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          showTalkToSpecialistButton={showTalkToSpecialistButton}
        />
      </div>

      <div className="flex items-center gap-4 @lg:hidden">
        {showTalkToSpecialistButton && (
          <Cta
            variation="flat"
            href={phone}
            text="Call now"
            icon={<Phone />}
            iconSide="left"
            size="sm"
            data-cta-phone
          />
        )}

        {navLinks && navLinks.length > 0 && (
          <button
            title="Main menu"
            aria-label="Main menu"
            onClick={onToggleMenuOpen}
            className="text-brand-default cursor-pointer hover:brightness-90"
          >
            <Hamburger className="h-6 w-6 group-open:hidden" />
            <XClose className="w-6 h-6 hidden group-open:block" />
          </button>
        )}
      </div>
    </nav>
  );
}
